export function isUnknownYear(dateString: string) {
  // The API return 1 as the year when it's unknown
  return dateString.startsWith('1-');
}
